import React from 'react';
import { Box, Progress, Flex, Text, Center, VStack } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

const ModernLoader = ({ message = "Loading...", h = "100vh" }) => {
    return (
        <Center h={h} w="100%" bg={h === "100vh" ? "#f4f1ec" : "transparent"}>
            <VStack spacing={6} w="100%" maxW="400px" px={4}>
                <MotionBox
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                >
                    <VStack spacing={2}>
                        {h === "100vh" && (
                            <Text fontSize="2xl" fontWeight="900" color="blue.600" letterSpacing="widest" mb={2}>
                                IEP SYSTEM
                            </Text>
                        )}
                        <Text fontSize="sm" color="gray.500" fontWeight="600">
                            {message}
                        </Text>
                    </VStack>
                </MotionBox>

                <Box w="100%" borderRadius="full" overflow="hidden" boxShadow="xs" bg="white" p={1}>
                    <Progress
                        size="xs"
                        isIndeterminate
                        colorScheme="blue"
                        borderRadius="full"
                        hasStripe
                        isAnimated
                    />
                </Box>
            </VStack>
        </Center>
    );
};

export default ModernLoader;
